<mat-form-field class="form-field" [ngClass]="field.inputType" [formGroup]="group" [ngStyle]="field.containerStyles"
  [color]="field.color">

  <ng-container *ngIf="field.prefix">
    <span *ngIf="field.prefix.label" matPrefix (click)="prefixClick()">{{field.prefix.label}}</span>
    <button mat-icon-button *ngIf="field.prefix.icon" matPrefix (click)="prefixClick()">
      <mat-icon>{{field.prefix.icon}}</mat-icon>
    </button>

  </ng-container>
  <ng-container [ngSwitch]="field.inputType">
    <ng-container *ngSwitchCase="'textarea'">
      <textarea matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" [formControlName]="field.name"
        [placeholder]="field.label" [ngStyle]="field.inputStyles" [cdkTextareaAutosize]="field.autosize.enable"
        [cdkAutosizeMinRows]="field.autosize.minRows" [cdkAutosizeMaxRows]="field.autosize.maxRows"
        [ngClass]="field.inputClasses" [required]="field.required">
    </textarea>
    </ng-container>


    <ng-container *ngSwitchCase="'value'">
      <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (focus)="selectOnFocus($event)"
        [ngClass]="field.inputClasses" [ngStyle]="field.inputStyles" [formControlName]="field.name"
        [placeholder]="field.label" type="text" readonly>
    </ng-container>
    <!--
    <ng-container *ngSwitchCase="'tel'">
      <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (focus)="selectOnFocus($event)"
        mask="(00) 0000-00009" [showMaskTyped]="true" [ngClass]="field.inputClasses"
        [ngStyle]="field.inputStyles" [formControlName]="field.name" [placeholder]="field.label" type="text" readonly>
    </ng-container> -->

    <ng-container *ngSwitchCase="'text'">
      <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (focus)="selectOnFocus($event)"
        [ngClass]="field.inputClasses" [ngStyle]="field.inputStyles" [formControlName]="field.name"
        [placeholder]="field.label" [type]="field.inputType" [mask]="field.mask?.mask"
        [showMaskTyped]="field.showMaskTyped" [required]="field.required"
        [attr.autocomplete]="field.autoComplete ? field.autoComplete : 'off'" [attr.patterns]="field.mask?.patterns"
        [gioDateMask]="field.date">

    </ng-container>

    <ng-container *ngSwitchCase="'number'">
      <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (focus)="selectOnFocus($event)"
        [ngClass]="field.inputClasses" [min]="field.options?.min" [max]="field.options?.max"
        [step]="field.options?.step"
        [ngStyle]="field.inputStyles" [formControlName]="field.name" [placeholder]="field.label"
        [type]="field.inputType" [required]="field.required"
        [attr.autocomplete]="field.autoComplete ? field.autoComplete : 'off'">

    </ng-container>


    <ng-container *ngSwitchCase="'tel'">
      <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (focus)="selectOnFocus($event)"
        [ngClass]="field.inputClasses" [ngStyle]="field.inputStyles" [formControlName]="field.name"
        [placeholder]="field.label" [type]="'text'" mask="(00) 0000-00009" [showMaskTyped]="true"
        [required]="field.required" [attr.autocomplete]="field.autoComplete ? field.autoComplete : 'off'">

    </ng-container>

    <ng-container *ngSwitchCase="'amount'">
      <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (focus)="selectOnFocus($event)"
        [ngClass]="field.inputClasses" [ngStyle]="field.inputStyles" currencyMask [options]="currencyOptions"
        [formControlName]="field.name" [placeholder]="field.label" [type]="field.inputType" [required]="field.required"
        [attr.autocomplete]="field.autoComplete ? field.autoComplete : 'off'">

    </ng-container>

    <ng-container *ngSwitchDefault>
      <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (focus)="selectOnFocus($event)"
        [ngClass]="field.inputClasses" [ngStyle]="field.inputStyles" [formControlName]="field.name"
        [placeholder]="field.label" [type]="field.inputType" [required]="field.required" [mask]="field.mask?.mask"
        [showMaskTyped]="showMaskTyped || true" [attr.autocomplete]="field.autoComplete ? field.autoComplete : 'off'">

    </ng-container>


  </ng-container>

  <ng-container *ngIf="field.suffix">
    <span *ngIf="field.suffix.label" matSuffix (click)="suffixClick()">{{field.suffix.label}}</span>
    <button mat-icon-button *ngIf="field.suffix.icon" matSuffix (click)="suffixClick()">
      <mat-icon>{{field.suffix.icon}}</mat-icon>
    </button>

  </ng-container>

  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
  </ng-container>

</mat-form-field>
